import { createSelector } from 'reselect';
import { listViewColumns } from '../../constants/data';

const getCurrentSite = state => state.sites.currentSite;
const getAreas = state => state.areas.list;
const getZones = state => state.zones.list;
const getLocations = state => state.locations.list;
const getCategories = state => state.categories.list;
const getGroups = state => state.groups.list;
const getField1 = state => state.tags.field1FilterValues
const getField2 = state => state.tags.field2FilterValues

/**
  @name getListViewColumns
  Selector to obtain the columns config with filter options and custom headers
*/
const getListViewColumns = createSelector(
  [getCurrentSite, getAreas, getZones, getLocations, getCategories, getGroups, getField1, getField2],
  (currentSite, areas, zones, locations, categories, groups, field1, field2) => {
      const areaNames = areas.map(area => area.name);
      const zoneNames = zones.map(zone => zone.name);
      const locationNames = locations.map(location => location.name.split('@')[0]);
      const categoryNames = categories.map(category => category.name);
      const groupNames = groups.map(group => group.name);

      // Update array indices, if column order is changed
      listViewColumns[1].customFilterValues = areaNames;
      listViewColumns[2].customFilterValues = zoneNames;
      listViewColumns[3].customFilterValues = locationNames;
      listViewColumns[5].customFilterValues = categoryNames;
      listViewColumns[6].customFilterValues = groupNames;
      listViewColumns[7].customFilterValues = field1;
      listViewColumns[8].customFilterValues = field2;
      
      // Set custom headers if available
      listViewColumns.forEach(column => {
        if (column.customLabelKey) {
          column.Header = currentSite.labels && currentSite.labels[column.customLabelKey] ? 
            currentSite.labels[column.customLabelKey] : column.defaultHeader;
        } 
      })
      
      return listViewColumns;
  }
);

export default getListViewColumns;



// WEBPACK FOOTER //
// ./src/utils/selectors/getListViewColumns.js